import React from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './store/index';

import SearchContainer from './containers/SearchMain/Search';
import DashboardContainer from './containers/Dashboard/Dashboard';
import SearchDemo from './containers/SearchDemo/SearchDemo';
import SearchMobile from './containers/SearchMobile/SearchMobile';
import SearchMobileDemo from './containers/SearchMobileDemo/SearchMobileDemo';
import SearchBuyer from './containers/SearchMobile/SearchBuyer';

function App() {
  return (
    <Provider store={store}>
      <Router basename={`${process.env.PUBLIC_URL}`}>
        <Routes>
          <Route path="/">
            <Route path=":language" element={<SearchContainer />} />
          </Route>
          <Route path="demo" element={<SearchDemo />} />
          <Route path="dashboard" element={<DashboardContainer />} />
          <Route path="mobile">
            <Route path=":language" element={<SearchMobile />} />
            <Route path="demo" element={<SearchMobileDemo />} />
            <Route path="buyer" element={<SearchBuyer />}></Route>
          </Route>
        </Routes>
      </Router>
    </Provider>
  );
}

export default App;
